module.exports = __webpack_public_path__ + "img/2.748c0484.png";